import { render } from "./TvmColorSwatches.vue?vue&type=template&id=18ea3a28&scoped=true"
import script from "./TvmColorSwatches.vue?vue&type=script&lang=js"
export * from "./TvmColorSwatches.vue?vue&type=script&lang=js"

import "./TvmColorSwatches.vue?vue&type=style&index=0&id=18ea3a28&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ea3a28"],['__file',"src/Components/ChatWidget/TvmColorSwatches/TvmColorSwatches.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18ea3a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18ea3a28', __exports__)) {
    api.reload('18ea3a28', __exports__)
  }
  
  module.hot.accept("./TvmColorSwatches.vue?vue&type=template&id=18ea3a28&scoped=true", () => {
    api.rerender('18ea3a28', render)
  })

}


export default __exports__